import { render, staticRenderFns } from "./ActivityProfilesPage.vue?vue&type=template&id=1a08d460"
import script from "./ActivityProfilesPage.vue?vue&type=script&lang=js"
export * from "./ActivityProfilesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports